import { Component, Injector, OnInit } from '@angular/core';
import { AppConfiguration } from 'src/app/app-configuration';
import { ARTIFACT_KEY } from 'src/app/core/constants/artifacts-order.constants';
import { AppWizService } from 'src/app/core/services/app-wiz.service';
import { ArtifactBaseComponent } from '../artifact-base-component';
import { UploadService } from 'src/app/core/services/upload.service';
import { from, mergeMap } from 'rxjs';
import { ARTIFACT_STATUS, ARTIFACT_SUBMMITED_BY, ARTIFACT_TYPE } from 'src/app/core/enums/artifact.enum';
import { Router } from '@angular/router';
import { Artifact } from 'src/app/core/models/artifact.model';
import { UtilService } from 'src/app/core/services/util.service';
import { MiscellaneousService } from 'src/app/core/services/miscellaneous.service';

@Component({
  selector: 'app-form-download',
  templateUrl: './form-download.component.html',
  styleUrls: ['./form-download.component.scss']
})
export class FormDownloadComponent extends ArtifactBaseComponent implements OnInit {

  ARTIFACT_TYPE = ARTIFACT_TYPE;
  ARTIFACT_STATUS = ARTIFACT_STATUS;
  documents:any[] = [];
  constructor(
    private injector: Injector,
    public appConfig: AppConfiguration,
    public override appWizService : AppWizService,
    public override uploadService : UploadService,
    public utilService : UtilService,
    private miscService : MiscellaneousService,
    private router: Router,
  ) {
    super(injector)
  }

  initJsonData(){}
  validateJsonData(){}
  resetJsonData(){}

  download(artifact: Artifact) {
    // Artifacts with a templateType serve an admin-uploaded template from TemplateFiles,
    // resolved by (approach, templateType). Everything else is a generated form served from
    // the forms endpoint by naming convention.
    if (artifact.templateType) {
      this.downloadTemplateFile(artifact);
      return;
    }

    this.utilService.urlToBlob('forms', {form: artifact.formName, appId:artifact.appId}, artifact.name).subscribe((x:any) => {
      if(x){
        this.appWizService.updateDownloadedStatus(artifact);
      }
    });
  }

  private downloadTemplateFile(artifact: Artifact) {
    const approach = this.appWizService.appWizard?.approach;

    if (!approach || !artifact.templateType) {
      this.utilService.openSnackBar('Something went wrong with Download');
      return;
    }

    this.miscService.getTemplateFileContent(approach, artifact.templateType).subscribe({
      next: (res: any) => {
        if (!res?.fileContent) {
          this.utilService.openSnackBar('Something went wrong with Download');
          return;
        }

        const blob = this.utilService.b64toBlob(res.fileContent, 'application/pdf');
        this.utilService.blobtoDownload(blob, res.fileName || artifact.name);
        this.appWizService.updateDownloadedStatus(artifact);
      },
      error: () => {
        this.utilService.openSnackBar('Something went wrong with Download');
      }
    });
  }
}
